import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { getUserDetails } from "./utils/getUserDetails";
import { MIDDLEWARE } from "./constants/api";
import type { HeaderWebRef } from "@foundit/header/dist/HeaderWeb";
import RecruiterHeader from "@foundit/recruiterHeader";

export default function HeaderLayout() {
  const headerRef = useRef<HeaderWebRef>(null);

  const isLoginSuccess = useSelector((state: any) => state.quickActions.isLoginSuccess);
  const page_name = useSelector((state: any) => state.quickActions.page_name);
  const userDetails = getUserDetails();

  const [userData, setUserData] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);

  
  useEffect(() => {
    if (isLoginSuccess && userDetails && Object.keys(userDetails).length > 0 && page_name) {
      setUserData(userDetails);
    }
    setIsLoading(false);
  }, [isLoginSuccess, page_name, userDetails]);

  useEffect(() => {
    window.__globalHeaderRef__ = headerRef;
  }, []);
  
  if (isLoading) return <></>;

  return (
    <RecruiterHeader
        environment={
          process.env.NEXT_PUBLIC_CT_PROD_PROJECT_ID ||
          process.env.NEXT_PUBLIC_CT_TEST_PROJECT_ID ||
          "TEST-944-RZ9-9Z7Z"
        }
        page_name={page_name || "Folder Page"}
        page="FML"
        // middleware={""}
        ref={headerRef}
        isClevertapOn={true}
        // isRecallGetUser={true} //true if u want to call get user api every reload other wise will get it from session
        showBetaTag={false}
        isLoggedIn
        subContainerStyles={{ maxWidth: "unset", padding: "0 24px 0 24px" }}
        hideQuickSearch={true}
      />
  );
}
